'use strict';



function ___$insertStyle(css) {
  if (!css) {
    return;
  }
  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');

  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
require('./Switch.scss.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var Switch = function (_a) {
    var id = _a.id, showText = _a.showText, textPair = _a.textPair, emitSwitchStatus = _a.emitSwitchStatus, defaultStatus = _a.defaultStatus;
    var _b = React.useState(defaultStatus || false), switchStatus = _b[0], setSwitchStatus = _b[1];
    return (React__default['default'].createElement("div", { className: "switch__wrapper" },
        React__default['default'].createElement("div", { className: "switch " + (switchStatus ? 'switch-on' : 'switch-off') },
            React__default['default'].createElement("input", { id: id, type: "checkbox", checked: switchStatus, onChange: function (event) {
                    event.persist();
                    setSwitchStatus(event.target.checked);
                    emitSwitchStatus(event.target.checked);
                } }),
            React__default['default'].createElement("label", { htmlFor: "switch__checkbox", className: "switch__label" },
                React__default['default'].createElement("span", { className: "switch__circle" }))),
        showText
            && (React__default['default'].createElement("span", { className: "switch__text heading-sm-r" }, switchStatus ? "" + textPair.on : "" + textPair.off))));
};

exports.Switch = Switch;
//# sourceMappingURL=Switch.js.map
